"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prevMonthTotal = exports.thisMonthTotal = exports.todayTotal = exports.totalSMS = void 0;
var lodash_1 = require("lodash");
var now = new Date();
var prevMonth = now.getMonth() - 1;
var relevantYear = now.getYear();
if (prevMonth === -1) {
    relevantYear--;
    prevMonth = 11;
}
var smsLen = function (el) {
    var len;
    if (el.smsInfo.smsCount) {
        len = el.smsInfo.smsCount;
    }
    else if (el.smsInfo.sms) {
        if (el.smsInfo.sms.data) {
            len = el.smsInfo.sms.data.length;
        }
        else {
            len = el.smsInfo.sms.length;
        }
    }
    else {
        len = 1;
    }
    return len;
};
var totalSMS = function (arr) {
    var totalCount = (0, lodash_1.sum)(arr.filter(function (i) {
        return i;
    }).map(function (curr) { return smsLen(curr); }));
    return totalCount;
};
exports.totalSMS = totalSMS;
var todayTotal = function (arr) {
    var todayTotal = arr.filter(function (i) {
        var date = new Date(i.createdAt);
        return date.getMonth() === now.getMonth()
            && date.getYear() === now.getYear()
            && date.getDate() === now.getDate();
    }).reduce(function (prev, curr) {
        return prev + smsLen(curr);
    }, 0);
    return todayTotal;
};
exports.todayTotal = todayTotal;
var thisMonthTotal = function (arr) {
    var thisMonthTotal = arr.filter(function (i) {
        var date = new Date(i.createdAt);
        return date.getMonth() === now.getMonth()
            && date.getYear() === now.getYear();
    }).reduce(function (prev, curr) {
        return prev + smsLen(curr);
    }, 0);
    return thisMonthTotal;
};
exports.thisMonthTotal = thisMonthTotal;
var prevMonthTotal = function (arr) {
    var prevMonthTotal = arr.filter(function (i) {
        var date = new Date(i.createdAt);
        return date.getMonth() === prevMonth
            && date.getYear() === relevantYear;
    }).reduce(function (prev, curr) {
        return prev + smsLen(curr);
    }, 0);
    return prevMonthTotal;
};
exports.prevMonthTotal = prevMonthTotal;
//# sourceMappingURL=CountSMS.js.map